import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { 
  Home, 
  Monitor, 
  Server, 
  BookOpen, 
  HelpCircle, 
  ChevronLeft, 
  ChevronRight, 
  User, 
  Users,  
  FolderKanban, 
  Clock, 
  Layers,
  Siren,
  Bell
} from "lucide-react";
import { canAccessUsers } from '../utils/permissions';

const Sidebar = ({isOpen, toggleSidebar}) => {
  const { role, name } = useSelector(state => state.auth.user);
  
  const menuItems = [
    { icon: Home, text: "Home", path: "/" },
    { icon: FolderKanban, text: "My Projects", path: "/projects" },
    { icon: Layers, text: "My Resources", path: '/resources' },
    { icon: Siren, text: "My Alarms", path: "/alarms" },
    { icon: Clock, text: "Run Batch Jobs", path: "/batch-jobs" },
    { icon: BookOpen, text: "Documentation", path: "/docs" },
    { icon: HelpCircle, text: "Support", path: "/support" },
  ];

  return (
    <div className={`fixed h-screen ${isOpen ? 'w-64' : 'w-16'} bg-gray-900 overflow-y-auto text-white transition-all duration-300 ease-in-out`}>
      <div className="p-4">
        <div className="flex justify-between items-center mb-4">
          {isOpen && <h2 className="text-2xl font-bold font-serif">Cloudify</h2>}
          <button onClick={toggleSidebar} className="p-2 hover:bg-gray-700 rounded">
            {isOpen ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
          </button>
        </div>
        <ul>
          {menuItems.map((item, index) => (
            <li key={index} className="mb-2">
              <Link to={item.path} className="flex items-center p-2 hover:bg-gray-700 rounded">
                <span className="mr-2">
                  <item.icon size={20} />
                </span>
                {isOpen && <span>{item.text}</span>}
              </Link>
            </li>
          ))}
          
          
          
          {canAccessUsers(role) && (
            <li className="mb-2">
              <Link to="/users" className="flex items-center p-2 hover:bg-gray-700 rounded">
                <span className="mr-2">
                  <Users size={20} />
                </span>
                {isOpen && <span>Users</span>}
              </Link>
            </li>
          )}
        </ul>
      </div>
      <div className="absolute bottom-0 w-full p-4 bg-gray-800 hover:bg-gray-700 transition-colors duration-200">
        <div className="flex items-center">
          <div className="w-10 h-10 rounded-full bg-gray-600 flex items-center justify-center flex-shrink-0">
            <User size={20} />
          </div>
          {isOpen && (
            <div className="ml-3 overflow-hidden">
              <div className="font-medium truncate max-w-[160px]">{name}</div>
              <div className="text-sm text-gray-400 capitalize truncate max-w-[160px]">{role}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;